/**
 * Defines possible exit types for a node
 */
export const enum Exit {
    Complete = "Complete",
    Skip = "Skip",
    Error = "Error",
    True = "True",
    False = "False",
    Repeat = "Repeat",
    Custom = "Custom",
    Collapse = "Collapse"
}

/**
 * Converts a string to it's corresponding exit type from Exit enum
 * @param str string
 *
 * @return Exit
 */
export const GetExitFromString = (str: string) => {
    str = str.toLowerCase();

    if (str === "complete") {
        return Exit.Complete;
    } else if (str === "skip") {
        return Exit.Skip;
    } else if (str === "error") {
        return Exit.Error;
    } else if (str === "true") {
        return Exit.True;
    } else if (str === "false") {
        return Exit.False;
    } else if (str === "repeat") {
        return Exit.Repeat;
    } else if (str === "collapse") {
        return Exit.Collapse;
    } else {
        return Exit.Custom;
    }
};



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/data/exit.ts